import React, { useMemo } from 'react';
import Snowfall from 'react-snowfall';
import angpaoImg from '../assets/angpau/angpao.png';
import coinImg from '../assets/angpau/coin.png';
import lionImg from '../assets/angpau/lion-dance.png';
import fireImg from '../assets/angpau/fire-cracker.png';

export default function AngpaoAndCoinRain({ isVisible = true }) {
  const expiryDate = new Date(2026, 1, 17);
  const isExpired = new Date() > expiryDate;

  const images = useMemo(() => {
    if (isExpired) return [];
    const angpao = document.createElement('img');
    angpao.src = angpaoImg;

    const coin = document.createElement('img');
    coin.src = coinImg;

    const lionDance = document.createElement('img');
    lionDance.src = lionImg;

    const fireCraker = document.createElement('img');
    fireCraker.src = fireImg;

    return [angpao, coin, lionDance, fireCraker];
  }, [isExpired]);

  if (!isVisible || isExpired) return null;

  return (
    <Snowfall
      style={{
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
      images={images}
      radius={[15, 30]}
      snowflakeCount={20}
      speed={[1.0, 3.0]}
      wind={[-0.5, 2.0]}
    />
  );
}
